export const RECOMMENDATIONS_MANIFEST_INFO_SETTING_KEY = 'recommendationsManifestInfo';

/** Ключ настройки с манифестом микрофронтенда рекламного баннера (node -> browser) */
export const AD_BANNER_MF_MANIFEST_SETTING_KEY = 'adBannerMicrofrontendManifest';
